import { Nl2Br } from '@findy-code/yuffie/shared/nl2br';
import { Heading } from '@findy-code/yuffie/ui/heading';
import { Stack } from '@findy-code/yuffie/ui/stack';
import { Text } from '@findy-code/yuffie/ui/text';
import { useId, useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';

import styles from './company-detail-vision.component.module.scss';
import { SectionLayout } from './section-layout.component';

type ContentProps = {
  content?: string;
  title: string;
  type: 'mission' | 'vision';
};

export const CompanyDetailMissionVision = ({
  title,
  content,
  type,
}: ContentProps) => {
  const [isAccordionOpen, setAccordionIsOpen] = useState(false);

  const triggerId = useId();
  const contentId = useId();

  return (
    <SectionLayout
      heading={{
        title: type === 'mission' ? 'ミッション' : 'ビジョン',
      }}
      id={type}
    >
      <Stack
        aria-expanded={isAccordionOpen}
        className={styles.accordionWrapper}
        spacing={0}
      >
        {content ? (
          <>
            <button
              aria-controls={`content-${contentId}`}
              className={styles.accordionTitle}
              id={`trigger-${triggerId}`}
              onClick={() => setAccordionIsOpen((pre) => !pre)}
            >
              <Heading align="left" as="h3" font="heading-l">
                {title}
              </Heading>
              <div aria-hidden="true" className={styles.accordionToggleIcon}>
                <FaChevronDown size={16} />
              </div>
            </button>
            <div
              aria-labelledby={`trigger-${triggerId}`}
              className={styles.accordionContent}
              id={`content-${contentId}`}
              role="region"
            >
              <Text as="p" font="body-m">
                <Nl2Br addLink text={content} />
              </Text>
            </div>
          </>
        ) : (
          <Heading align="left" as="h3" font="heading-l">
            {title}
          </Heading>
        )}
      </Stack>
    </SectionLayout>
  );
};
